// components/OrdersList.js
import React from "react";

const OrdersList = ({ orders }) => {
  if (!orders || orders.length === 0) return <p>No orders available.</p>;

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    background: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
  };

  const thStyle = {
    borderBottom: "2px solid #ddd",
    padding: "12px",
    background: "#3498db",
    color: "#fff",
    textAlign: "left",
  };

  const tdStyle = { borderBottom: "1px solid #eee", padding: "12px" };

  return (
    <div>
      <h2 style={{ marginBottom: "20px" }}>All Orders</h2>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>SL No.</th>
            <th style={thStyle}>Order ID</th>
            <th style={thStyle}>Date</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Total ($)</th>
            <th style={thStyle}>Customer</th>
            <th style={thStyle}>Billing Address</th>
            <th style={thStyle}>Products</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => (
            <tr key={order.id}>
              <td style={tdStyle}>{index + 1}</td>
              <td style={tdStyle}>{order.id}</td>
              <td style={tdStyle}>{new Date(order.date_created).toLocaleString()}</td>
              <td style={tdStyle}>{order.status}</td>
              <td style={tdStyle}>{order.total}</td>
              <td style={tdStyle}>{order.billing.first_name} {order.billing.last_name}</td>
              <td style={tdStyle}>
                {order.billing.address_1}, {order.billing.city}, {order.billing.state}, {order.billing.postcode}, {order.billing.country}
              </td>
              <td style={tdStyle}>
                {order.line_items.map(item => (
                  <div key={item.id}>{item.name} x {item.quantity} (${item.price})</div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersList;
